import React, { useState } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

interface Props {
  open: boolean;
  onClose: () => void;
  shareUrl: string;
}

export default function ShareReportModal({ open, onClose, shareUrl }: Props) {
  const [copied, setCopied] = useState(false);
  if (!open) return null;

  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  };

  return createPortal(
    <div className="fixed inset-0 z-[9000] flex items-center justify-center p-4" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#EEF1F4]">
          <h2 className="text-base font-bold text-ink">Share report</h2>
          <button type="button" onClick={onClose} aria-label="Close" className="text-ink3 hover:text-ink"><X className="w-5 h-5" /></button>
        </div>
        <div className="px-5 py-4">
          <p className="text-[12.5px] text-ink3 mb-3">Copy the link below. Anyone with the link who can sign in to your business will see this report at its current period and filters.</p>
          <label className="block text-[13px] text-ink mb-2 font-medium">Shareable link</label>
          <div className="flex gap-2">
            <input readOnly value={shareUrl} onClick={(e) => (e.target as HTMLInputElement).select()} className="flex-1 h-[42px] border border-[#D8DEE6] rounded-lg px-3.5 text-[13.5px] bg-white" />
            <button type="button" onClick={handleCopy} className="h-[42px] px-4 border border-[#D8DEE6] rounded-lg text-[13px] font-semibold text-ink bg-white hover:bg-[#EEF4FB]">
              {copied ? "Copied!" : "Copy link"}
            </button>
          </div>
        </div>
        <div className="flex justify-end gap-2.5 px-5 py-3 border-t border-[#EEF1F4] bg-[#F7F9FB]">
          <button type="button" onClick={onClose} className="h-[40px] px-5 border border-ink rounded-[10px] text-[13.5px] font-semibold text-white bg-ink">Close</button>
        </div>
      </div>
    </div>,
    document.body
  );
}